import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Flex } from 'foundations-components/components/Flex';
import { memo, useCallback, useContext } from 'react';
import { CommentsContext } from 'object-comments-thread-lib/contexts/CommentsContext';
import { CallCommentsContext } from 'object-comments-thread-lib/contexts/CallCommentsContext';
import I18n from 'I18n';
import { CommentsIcon } from 'foundations-assets/icons/components/CommentsIcon';
import { CopyIcon } from 'foundations-assets/icons/components/CopyIcon';
import { ShareIcon } from 'foundations-assets/icons/components/ShareIcon';
import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import { getUtteranceAsPlainText } from '../../utils/transcriptUtils';
import { getUtteranceId } from '../../utils/idHelpers';
import { TRANSCRIPT_UTTERANCES_CONTAINER_ID } from '../../constants/ContainerIds';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UtteranceActionButtons = ({
  utteranceData,
  onCommentIconClick,
  onCopyIconClick,
  onShareIconClick,
  renderCommentButton
}) => {
  const {
    setIsCommenting
  } = useContext(CommentsContext);
  const {
    setAnchorCallTime
  } = useContext(CallCommentsContext);
  const handleShareIconClick = useCallback(() => {
    if (onShareIconClick) {
      onShareIconClick(utteranceData.startTimeSeconds);
    }
  }, [onShareIconClick, utteranceData.startTimeSeconds]);
  const handleCommentIconClick = useCallback(() => {
    if (onCommentIconClick) {
      onCommentIconClick();
      setIsCommenting(true);
      setAnchorCallTime(utteranceData.startTimeSeconds);
    }
  }, [onCommentIconClick, setAnchorCallTime, setIsCommenting, utteranceData.startTimeSeconds]);
  const handleShareIconKeyPress = useCallback(e => {
    if (e.key === 'Enter') {
      handleShareIconClick();
    }
  }, [handleShareIconClick]);
  const handleCommentIconKeyPress = useCallback(e => {
    if (e.key === 'Enter') {
      handleCommentIconClick();
    }
  }, [handleCommentIconClick]);
  const handleCopyIconClick = useCallback(() => {
    if (!onCopyIconClick) return;
    if (typeof utteranceData.utterance === 'string') {
      onCopyIconClick(getUtteranceAsPlainText(utteranceData));
    }
  }, [onCopyIconClick, utteranceData]);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    flexWrap: "nowrap",
    children: [renderCommentButton && renderCommentButton(utteranceData, getUtteranceId(utteranceData, TRANSCRIPT_UTTERANCES_CONTAINER_ID)) || onCommentIconClick && /*#__PURE__*/_jsx(IconButton, {
      use: "link",
      onClick: handleCommentIconClick,
      "data-test-id": "utteranceCommentIcon",
      "aria-label": I18n.text('recordingReviewComponents.transcript.utterance.commentIconAriaLabel'),
      onKeyDown: handleCommentIconKeyPress,
      children: /*#__PURE__*/_jsx(CommentsIcon, {
        size: "300"
      })
    }), onCopyIconClick && /*#__PURE__*/_jsx("span", {
      onClick: e => e.stopPropagation(),
      children: /*#__PURE__*/_jsx(CopyButton, {
        use: "unstyled",
        marginInlineStart: "200",
        onClick: handleCopyIconClick,
        "data-test-id": "utteranceCopyIcon",
        "aria-label": I18n.text('recordingReviewComponents.transcript.utterance.copyIconAriaLabel'),
        value: getUtteranceAsPlainText(utteranceData),
        children: /*#__PURE__*/_jsx(CopyIcon, {
          size: "300"
        })
      })
    }), onShareIconClick && /*#__PURE__*/_jsx(IconButton, {
      "data-test-id": "utteranceShareIcon",
      use: "link",
      marginInlineStart: "200",
      onClick: handleShareIconClick,
      onKeyDown: handleShareIconKeyPress,
      "aria-label": I18n.text('recordingReviewComponents.transcript.utterance.shareIconAriaLabel'),
      children: /*#__PURE__*/_jsx(ShareIcon, {
        size: "300"
      })
    })]
  });
};
export default /*#__PURE__*/memo(UtteranceActionButtons);